(function () {
  function destroySwiper(sectionId) {
    var key = 'beReadSwiper_' + sectionId;
    var inst = window[key];
    if (inst && typeof inst.destroy === 'function') inst.destroy(true, true);
    window[key] = null;
  }

  function initSwiper(sectionId) {
    var key = 'beReadSwiper_' + sectionId;
    if (window[key]) return;
    var el = document.getElementById('be-read-swiper-' + sectionId);
    if (!el) return;

    if (typeof window.Swiper === 'undefined') {
      setTimeout(function () { initSwiper(sectionId); }, 50);
      return;
    }

    window[key] = new Swiper(el, {
      slidesPerView: 1.5,
      spaceBetween: 16,
      speed: 400,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
          allowTouchMove: false
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-be-read-section]').forEach(function (root) {
      initSwiper(root.dataset.beReadSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail) destroySwiper(e.detail.sectionId);
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail) return;
    destroySwiper(e.detail.sectionId);
    initSwiper(e.detail.sectionId);
  });
})();
